import { Container, Modal } from "react-bootstrap";
import PrimaryButton, {
  SecondaryButton,
} from "../../../util/Btns/PrimaryButton";

import Close from "../../../Assets/close.svg";
import styles from "./ResendInviteLinkModal.module.scss";
import { useResendInviteUser } from "../../../hooks/DevAuthHooks";

const ResendInviteLinkModal = ({ showResendInviteLinkModal, setShowResendInviteLinkModal, member }) => {
  const handleClose = () => setShowResendInviteLinkModal(false);
  const { mutate } = useResendInviteUser(setShowResendInviteLinkModal);
  const handleSubmit = () => {
    const data = { email: member?.email, userType: member?.userType };
    mutate(data);
  };
  return (
    <>
      <Container>
        <Modal
          show={showResendInviteLinkModal}
          onHide={handleClose}
          centered
          contentClassName={styles.content}
          dialogClassName={styles.dialog}
        >
          <Modal.Header className={styles.header}>
            <Modal.Title>
              <div style={{ padding: "0.25em" }}>
                <span
                  style={{ fontFamily: "JioType-Medium", fontSize: "medium" }}
                >
                  Resend Invite Link
                </span>
              </div>
            </Modal.Title>

            <img
              onClick={() => setShowResendInviteLinkModal(false)}
              style={{ marginTop: "15px" }}
              src={Close}
              height="14"
              width="14"
              alt="cross"
              className="cursor-pointer"
            />
          </Modal.Header>

          <Modal.Body>
            <div className={styles.body}>
              <h4>Are you sure you want to resend the invite link to {member.firstName} ?</h4>
              <div className={styles.buttonContainer}>
                <SecondaryButton onClick={() => setShowResendInviteLinkModal(false)}>
                  Cancel
                </SecondaryButton>
                <PrimaryButton
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  Resend Invite Link
                </PrimaryButton>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default ResendInviteLinkModal;
